module.exports = __webpack_public_path__ + "img/hk_room_floorplan_08.f4928703.png";